import { Edit2, Loader2, Save, X } from 'lucide-react';
import React from 'react';
import { SenderProfiles } from './SenderProfiles';
import styles from './sender-profiles.module.css';
import { useSenderProfiles } from './useSenderProfiles';

export const SenderProfilesTab: React.FC = () => {
  const {
    isLoading,
    isEditing,
    isSaving,
    saveError,
    profiles,
    schemaProperties,
    handleEdit,
    handleCancel,
    handleSave,
    addProfile,
    updateProfile,
    removeProfile,
  } = useSenderProfiles();

  const SaveIcon = isSaving ? Loader2 : Save;

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <Loader2 />
      </div>
    );
  }

  return (
    <div className={styles.tab}>
      <div className={styles.toolbar}>
        {!isEditing && (
          <button type="button" onClick={handleEdit} className={styles.secondaryButton}>
            <Edit2 />
            Edit
          </button>
        )}
        {isEditing && (
          <div className={styles.editActions}>
            <button type="button" onClick={handleCancel} className={styles.secondaryButton}>
              <X />
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSave}
              disabled={isSaving}
              data-loading={isSaving || undefined}
              className={styles.primaryButton}>
              <SaveIcon />
              Save
            </button>
          </div>
        )}
      </div>

      {saveError && <p className={styles.saveError}>{saveError}</p>}

      <SenderProfiles
        profiles={profiles}
        schemaProperties={schemaProperties}
        isEditing={isEditing}
        onAdd={addProfile}
        onUpdate={updateProfile}
        onRemove={removeProfile}
      />
    </div>
  );
};
